export default __webpack_public_path__ + "static/media/HIW1.489680b0.svg";